import * as yup from 'yup';

export const dealInputSchema = yup.object().shape({
    dealTypeId: yup.number().required(),
    dealName: yup.string().required(),
    market_id: yup.string().required(),
    constructionTypeId: yup.string().required(),
    useCoordinates: yup.boolean().required(),
    latitude: yup.number().when('useCoordinates', {
        is: true,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    longitude: yup.number().when('useCoordinates', {
        is: true,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    address: yup.string().when('useCoordinates', {
        is: false,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    acquisitionPrice: yup.number().required(),
    city: yup.string().when('useCoordinates', {
        is: false,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    county: yup.string().when('useCoordinates', {
        is: false,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    state: yup.string().when('useCoordinates', {
        is: false,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
    zipCode: yup.string().when('useCoordinates', {
        is: false,
        then: schema => schema.required(),
        otherwise: schema => schema.notRequired(),
    }),
});
